import 'flowbite';

// Load FontAwesome icons asynchronously to reduce initial bundle size
// Only load the icon sets actually used in the site
const loadFontAwesome = async () => {
  const { library, dom } = await import('@fortawesome/fontawesome-svg-core');
  const { fas } = await import('@fortawesome/free-solid-svg-icons');
  const { fab } = await import('@fortawesome/free-brands-svg-icons');
  
  // Add only the icon sets we actually use (no 'far' - not used anywhere)
  library.add(fas, fab);
  dom.watch();
};

// Load FontAwesome immediately but asynchronously
loadFontAwesome();

// Import AlpineJS
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import intersect from '@alpinejs/intersect';
Alpine.plugin(intersect);
Alpine.plugin(collapse);
window.Alpine = Alpine;
Alpine.start();

// Import component files with lazy loading for heavy libraries
import './components/smoothscroll.js';
import './components/announcements.js';

// Lazy load heavy components only when needed
const loadLightGallery = async () => {
  const galleries = document.querySelectorAll('.lightbox-gallery');
  if (galleries.length > 0) {
    const { default: initLightGallery } = await import('./components/lightgallery.js');
    initLightGallery();
  }
};

const loadFlickity = async () => {
  const sliders = document.querySelectorAll('.carousel-single, .carousel-multiple, .carousel-fullwidthHero');
  if (sliders.length > 0) {
    const { default: initFlickity } = await import('./components/flickity-sliders.js');
  }
};

// Load components based on DOM content
document.addEventListener('DOMContentLoaded', () => {
  // Load heavy components only if their elements exist
  loadLightGallery();
  loadFlickity();
});